module.exports = __webpack_public_path__ + "static/media/sponsor_group2.c4070aa9.png";